import animationBlue from 'img/nestleLanding/animations/nickname/blue.riv';
import bgBlue from 'img/nestleLanding/animations/nickname/blue_static.png';
import animationGreen from 'img/nestleLanding/animations/nickname/green.riv';
import bgGreen from 'img/nestleLanding/animations/nickname/green_static.png';
import animationPink from 'img/nestleLanding/animations/nickname/pink.riv';
import bgPink from 'img/nestleLanding/animations/nickname/pink_static.png';
import animationRed from 'img/nestleLanding/animations/nickname/red.riv';
import bgRed from 'img/nestleLanding/animations/nickname/red_static.png';
import { CardColor } from 'reactApp/sections/Nestle/PetsCard/PetsCard.types';

export const animations = {
    [CardColor.blue]: animationBlue,
    [CardColor.green]: animationGreen,
    [CardColor.red]: animationRed,
    [CardColor.pink]: animationPink,
};

export const backgroundImages = {
    [CardColor.blue]: bgBlue,
    [CardColor.green]: bgGreen,
    [CardColor.red]: bgRed,
    [CardColor.pink]: bgPink,
};
